import React from 'react';
import styles from './JsonViewer.module.scss';

const JsonViewer = ({ json, title }) => {
  const formattedJson = JSON.stringify(json, null, 2);

  return (
    <div className={styles.jsonViewer}>
      {title && <h5 className={styles.title}>{title}</h5>}
      <pre className={styles.pre}>
        <code>{formattedJson}</code>
      </pre>
    </div>
  );
};

export default JsonViewer;